export function formatName(name: string) {
	const splitedName = name.split(" ");
	return splitedName.length >= 2 ? `${splitedName[0]} ${splitedName[1]}` : name;
}
